import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

const LanguageSelectorPP = ({ selectedLanguage, handleCountryChange }) => {
  const clientSettings = useSelector(state => state.common.clientSettings);
  const countries = clientSettings.multilingual;
  const hasMultiLanguage = countries.filter(country => country.enable).length > 1;

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getCountryIcon = code => {
    const lowercaseCode = code.toLowerCase();

    switch (lowercaseCode) {
      case "enus":
        return "/assets/images/icon/icon-en-us-flag.png";
      case "zhcn":
        return "/assets/images/icon/icon-chn-flag.png";
      case "zhhk":
        return "/assets/images/icon/icon-hkd-flag.png";
      case "th":
        return "/assets/images/icon/icon-thb-flag.png";
      case "id":
        return "/assets/images/icon/icon-idr-flag.png";
      case "vi":
        return "/assets/images/icon/icon-viet-flag.png";
      case "ms":
        return "/assets/images/icon/icon-malaysia-flag.png";
      case "my":
        return "/assets/images/icon/icon-myanmar-flag.png";
      case "km":
        return "/assets/images/icon/icon-cambodia-flag.png";
      case "ko":
        return "/assets/images/icon/icon-south-korea-flag.png";
      case "ja":
        return "/assets/images/icon/icon-jpy-flag.png";
      case "ensg":
        return "/assets/images/icon/icon-sgd-flag.png";
      case "enhk":
        return "/assets/images/icon/icon-hkd-flag.png";
      default:
        return "/assets/images/icon/icon-sgd-flag.png";
    }
  };

  const formatCountryName = inputString => {
    const startIndex = inputString.indexOf("(");
    const endIndex = inputString.indexOf(")");

    if (startIndex !== -1 && endIndex !== -1 && startIndex < endIndex) {
      const beforeParentheses = inputString.substring(0, startIndex).trim();
      const afterParentheses = inputString.substring(endIndex + 1).trim();
      return `${beforeParentheses} ${afterParentheses}`;
    } else {
      return inputString.trim();
    }
  };

  if (!hasMultiLanguage) {
    return null;
  }

  return (
    <div className="footer-text">
      <div className="select-container">
        <button
          ref={dropdownRef}
          className={`custom-dropdown ${isDropdownOpen ? "open" : ""} noBg`}
          onClick={toggleDropdown}
        >
          <div className="selected-option">
            <div
              className="flag-icon"
              style={{ backgroundImage: `url(${getCountryIcon(selectedLanguage.id || "")})` }}
            />
            <span className="flag-text">{formatCountryName(selectedLanguage.name || "")}</span>
          </div>

          <ul className="options-list">
            {countries
              .filter(country => country.enable)
              .map(country => (
                <li key={country.language.id}>
                  <button
                    className="option noBgNoBorder"
                    onClick={() => handleCountryChange(country.language.code)}
                    title={`${country.language.code}`}
                  >
                    <div
                      className="flag-icon"
                      style={{ backgroundImage: `url(${getCountryIcon(country.language.id)})` }}
                    />
                    <span className="flag-name">{formatCountryName(country.displayText)}</span>
                  </button>
                </li>
              ))}
          </ul>
        </button>
      </div>
    </div>
  );
};

LanguageSelectorPP.propTypes = {
  selectedLanguage: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  handleCountryChange: PropTypes.func.isRequired,
};

export default LanguageSelectorPP;



// WEBPACK FOOTER //
// ./components/common/LanguageSelectorPP.js